import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Lightweight wrapper around the global gtag function.
 * Safely no-ops during development if GA isn't configured yet.
 */
const getGtag = (): ((...args: any[]) => void) | undefined => {
  if (typeof window === 'undefined') return undefined;
  return (window as any).gtag as ((...args: any[]) => void) | undefined;
};

export const trackEvent = (eventName: string, params?: Record<string, any>) => {
  const gtag = getGtag();
  if (!gtag) return;

  gtag('event', eventName, params);
};

/**
 * Component that tracks page views on route changes in a SPA.
 * Place this inside your Router so it can access location.
 */
export const AnalyticsListener: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const gtag = getGtag();
    if (!gtag) return;

    gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
    });
  }, [location]);

  return null;
};


